import React from "react";
import { Box, TextField, Autocomplete, Chip, FormLabel } from "@mui/material";

const FormikAutocompleteChips = ({ formik, name, label, placeholder }) => {
  const value = formik.values[name];

  return (
    <Box>
      <FormLabel sx={{ fontStyle: "inherit", color: "#000000" }}>
        {label}
      </FormLabel>

      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}>
        <Autocomplete
          sx={{
            width:"340px"
          }}
          multiple
          freeSolo
          options={[]}
          value={value}
          onChange={(event, newValue) => {
            formik.setFieldValue(name, newValue);
          }}
          renderTags={() => null}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder={placeholder}
              sx={{  "& .MuiOutlinedInput-root": {
                borderRadius: 3,
                bgcolor: "white"
              } }}
              error={formik.touched[name] && Boolean(formik.errors[name])}
              helperText={formik.touched[name] && formik.errors[name]}
              onBlur={() => formik.setFieldTouched(name, true)}
            />
          )}
        />

        <Box display="flex" gap={2} flexWrap="wrap">
          {value.map((option, index) => (
            <Chip
              key={index}
              label={option}
              onDelete={() => {
                const updated = [...value];
                updated.splice(index, 1);
                formik.setFieldValue(name, updated);
              }}
              sx={{
                borderRadius: "12px",
                width: "170px",
                py: 3.1,
                backgroundColor: "#D6B98138",
                position: "relative",
                "& .MuiChip-deleteIcon": {
                  position: "absolute",
                  top: "-6px",
                  right: "-10px",
                  width: "24px",
                  height: "24px",
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  color: "#B08B4F",
                  "&:hover": {
                    color: "#ef5350",
                  },
                },
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default FormikAutocompleteChips;
